/* ============================================================
 * <lion-recently-viewed>
 * - Tracks visited product handles in localStorage.
 * - Renders a card grid by fetching /products/{handle}?view=card
 *   (templates/product.card.liquid, layout: none).
 * - Stays hidden until at least one card renders.
 * ============================================================ */

(function () {
const STORAGE_KEY = 'lion:lion-recently-viewed';
const MAX_STORED = 20;

function readHandles() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

function writeHandles(list) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch { /* quota */ }
}

function track(handle) {
  if (!handle) return;
  const current = readHandles().filter((h) => h !== handle);
  current.unshift(handle);
  writeHandles(current);
}

class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.currentHandle = this.dataset.currentHandle || '';
    this.max = parseInt(this.dataset.max, 10) || 4;
    this.target = this.querySelector('[data-recently-viewed-target]');

    // Track current page if it's a product page.
    if (this.currentHandle) track(this.currentHandle);

    this.render();
  }

  async render() {
    const handles = readHandles()
      .filter((h) => h !== this.currentHandle)
      .slice(0, this.max);

    if (!handles.length || !this.target) return;

    const results = await Promise.all(handles.map((h) => this.fetchCard(h)));
    const html = results.filter(Boolean).map((card) => `<li class="recently-viewed__item">${card}</li>`).join('');
    if (html) {
      this.target.innerHTML = html;
      this.removeAttribute('hidden');
    }
  }

  async fetchCard(handle) {
    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}?view=card`);
      if (!res.ok) return null;
      const text = await res.text();
      // view=card renders the card snippet with layout none, so the
      // body is directly the card HTML.
      return text.trim();
    } catch {
      return null;
    }
  }
}

if (!customElements.get('lion-recently-viewed')) {
  customElements.define('lion-recently-viewed', RecentlyViewed);
}
})();
